export default "__VITE_ASSET__CpcslqCl__"